import React from 'react';
import {
  IconCheckboxChecked,
  IconCircleFilled,
  IconWarningTriangle,
} from '../icons';
import { PeriodicityPeriodStatus } from '@allbin/mobilix-utils';

export const getPeriodStatusColorIcon = (
  status: PeriodicityPeriodStatus,
): React.ReactElement => {
  if (status.executed === 'on_time' && status.remarks.length > 0) {
    return <IconWarningTriangle className="size-6 text-red-500" />;
  }

  if (status.executed === 'on_time') {
    return <IconCheckboxChecked className="size-6 text-green-500" />;
  }

  if (status.executed === 'late') {
    return <IconCircleFilled className="size-6 text-yellow-500" />;
  }

  return <IconCircleFilled className="size-6 text-red-500" />;
};
